import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const getDefaultState = () => {
  return {
    welcomeOffer: null,
    worldCredits: {},
    deals: {},
    subscriptions: null,
    states: {
      getProducts: {
        fetching: false,
        error: false,
        msg: null
      }
    }
  }
}

const state = getDefaultState()

mutations.RESET_STATE = (state) => {
  Object.assign(state, getDefaultState())
}
actions.reset = ({ commit }) => {
  commit('RESET_STATE')
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/communication/products/index.js